<template>
  <div>
    <el-dialog :title="$t('Məsul_şəxs')" :visible.sync="showModal" width="30%" top="30vh" append-to-body
      :close-on-press-escape="false" :close-on-click-modal="false">
      <client-service-users v-model="clientServiceUid" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ClientServiceUsers from "../components/ClientServiceUsers.vue";
import { ClientServiceUserUpdate } from "../../services/accident";
export default {
  components: {
    ClientServiceUsers,
  },
  data() {
    return {
      showModal: false,
      items: [], 
      clientServiceUid: null,
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    edit(items) {
      this.items = items;
      this.showModal = true;
    },
    clickSave() {
      Promise.all(
        this.items.map((item) =>
          ClientServiceUserUpdate(item.id, this.clientServiceUid, this.uid)
        )
      ).then((responses) => {
        responses.forEach((response, index) => {
          const currentItem = this.items[index];
          if (response.data.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0]
                  ? response.data.errors[0]
                  : this.$t('Səhv_əməliyyat'),
              });
            } else {
            }
          } else {
          }
        });

        this.showModal = false;
        this.$emit("refresh-table");
        this.$message({
          type: "success",
          message: this.$t('Uğurlu_əməliyyat'),
        });
      });
    }
  },
};
</script>

<style scoped>

</style>
